import React from 'react';
import dompurify from 'dompurify';

export const UserExplanationSeparator = '**';

const separator = UserExplanationSeparator.split('')
  .map(x => `\\${x}`)
  .join('');

export const FeatureUserExplanationDisplay = (props: {
  userExplanation: string;
}) => {
  const html = React.useMemo(() => {
    const styledText = props.userExplanation.replaceAll(
      new RegExp(`${separator}(.*?)${separator}`, 'gm'),
      x =>
        `<span style="color: var(--c-blue-700); font-weight: 500;">${x.replaceAll(
          UserExplanationSeparator,
          ''
        )}</span>`
    );
    return dompurify.sanitize(styledText);
  }, [props.userExplanation]);

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    ></span>
  );
};
